import {
    call,
    takeLatest,
} from 'redux-saga/effects';
import { AppAction } from './enum';
import { Actions } from './action';
import { debugInfo } from '@vfde-sails/utils';

/**
 * Initializes the state of the application
 */
export function* initStoreSaga (action: Actions) {
    yield call(debugInfo, 'init');
    // TODO: tracking?
}

/**
 * App Container saga
 */
export default function* saga () {
    yield takeLatest(AppAction.InitStore, initStoreSaga);
}
